import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function Pricing() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data.filter((c) => c.show_in_pricing !== false))).catch(() => {});
  }, []);

  return (
    <main data-testid="pricing-page" className="pt-32 pb-28">
      <Seo title="Pricing — Bahare | Photography Sessions in Los Angeles"
        description="Photography session pricing — maternity, newborn, family, couples, portraits, branding, events and products in Los Angeles." />
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#7A7A7A] mb-4">Pricing</p>
          <h1 className="font-serif text-5xl md:text-6xl font-light tracking-tight mb-4">Simple, honest <span className="italic">pricing.</span></h1>
          <p className="text-sm text-[#4A4A4A] leading-relaxed mb-8 max-w-md">
            Every session is tailored to you — send a request and I'll confirm the exact details and availability personally.
          </p>
        </Reveal>

        <div className="mt-16 space-y-20">
          {categories.map((c, i) => (
            <Reveal key={c.id} data-testid={`pricing-section-${c.slug}`}>
              <div className={`grid md:grid-cols-2 gap-8 md:gap-12 items-center ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`}>
                <Link to={`/photography/${c.slug}`} className="block overflow-hidden group bg-[#EFEFEC]">
                  <img src={imgUrl(c.cover_image)} alt={c.name} loading="lazy"
                    className="w-full aspect-[4/3] object-cover group-hover:scale-[1.03] transition-transform duration-[1200ms] ease-out" />
                </Link>
                <div>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-[#7A7A7A] mb-3">{String(i + 1).padStart(2, "0")}</p>
                  <h2 className="font-serif text-4xl font-light mb-4">{c.name}</h2>
                  {c.description && <p className="text-sm text-[#4A4A4A] leading-relaxed mb-6 max-w-sm whitespace-pre-wrap break-words">{c.description}</p>}
                  {c.starting_price && (
                    <p className="text-lg tracking-wide mb-8" data-testid={`pricing-price-${c.slug}`}>{c.starting_price}</p>
                  )}
                  <div className="flex items-center gap-6">
                    <Link to={`/book?category=${c.slug}`} data-testid={`pricing-book-${c.slug}`}
                      className="inline-flex items-center gap-2 bg-[#1A1A1A] text-[#F9F9F8] text-[11px] uppercase tracking-[0.2em] px-8 py-3.5 rounded-full hover:bg-[#4A4A4A] transition-colors">
                      Send Request <ArrowRight size={12} strokeWidth={1.5} />
                    </Link>
                    <Link to={`/photography/${c.slug}`} data-testid={`pricing-gallery-${c.slug}`}
                      className="text-[11px] uppercase tracking-[0.2em] text-[#7A7A7A] hover:text-[#1A1A1A] transition-colors border-b border-[#1A1A1A]/20 pb-1">
                      View Gallery
                    </Link>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
